


import { Dispatch } from 'redux';
import { LoginService } from "../../services/LoginService";
import { donorapi } from "../../ApiNames";

export const fetchdatasuccess = (data:any)=>({
    type : 'FETCH_DATA_SUCCESS',
    payload:data
})

export const fetchdata = (uid:any,fundid:any,rid:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const payload = {uid:uid,org:fundid,year1:rid};
            const apiname = donorapi.dorgtranscript;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchdatasuccess(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    }
}




